import { useCallback, useEffect, useRef, useState } from 'react';

import { useIntl, defineMessages } from 'react-intl';

import MoreHorizIcon from '@/material-icons/400-24px/more_horiz.svg?react';
import { Icon } from 'mastodon/components/icon';
import { LoadingIndicator } from 'mastodon/components/loading_indicator';

const messages = defineMessages({
  load_more: { id: 'status.load_more', defaultMessage: 'Load more' },
});

interface Props<T> {
  disabled: boolean;
  param: T;
  onClick: (params: T) => void;
  automatic?: boolean;
}

export const LoadGap = <T,>({ disabled, param, onClick, automatic = false }: Props<T>) => {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);
  const requested = useRef(false);

  useEffect(() => {
    if (automatic && !disabled && !requested.current) {
      requested.current = true;
      onClick(param);
    }
  }, [automatic, disabled, param, onClick]);

  const handleClick = useCallback(() => {
    setLoading(true);
    onClick(param);
  }, [setLoading, param, onClick]);

  if (automatic) return null;

  return (
    <button
      className='load-more load-gap'
      disabled={disabled}
      onClick={handleClick}
      aria-label={intl.formatMessage(messages.load_more)}
      title={intl.formatMessage(messages.load_more)}
      type='button'
    >
      {loading ? (
        <LoadingIndicator />
      ) : (
        <Icon id='ellipsis-h' icon={MoreHorizIcon} />
      )}
    </button>
  );
};
